import { createAddSmartFeedItemSeenActivityUrl } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";
import { useRouterLocale } from "src/utils/router/use-router-locale";

interface IFeedActivityRequest {
    ids: string[];
    parameter?: string;
}

export function useFeedSeenActivityMutation() {
    const { language, country } = useRouterLocale();

    const { mutatePromise } = useMutation<void, unknown, IFeedActivityRequest>(createAddSmartFeedItemSeenActivityUrl(language, country));

    return mutatePromise;
}
